import { render, staticRenderFns } from "./AccountSetUpOne.vue?vue&type=template&id=756aed54&"
import script from "./AccountSetUpOne.vue?vue&type=script&lang=js&"
export * from "./AccountSetUpOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports